import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Button, Input, Card, Row, Col } from 'antd';
import { SketchPicker } from 'react-color';

const { TextArea } = Input;

export default function TagForm({ onSubmit, initialData, onCancel }) {
    const {
        control,
        handleSubmit,
        setValue,
        watch,
        formState: { errors },
        reset,
    } = useForm({
        defaultValues: {
            name: '',
            description: '',
            color: '#6c757d',
        },
    });

    const watchedValues = watch();

    React.useEffect(() => {
        if (initialData) {
            reset({
                name: initialData.name || '',
                description: initialData.description || '',
                color: initialData.color || '#6c757d',
            });
        }
    }, [initialData, reset]);

    const handleFormSubmit = (data) => {
        onSubmit(data);
    };

    const handleColorChange = (color) => {
        setValue('color', color.hex);
    };

    return (
        <form onSubmit={handleSubmit(handleFormSubmit)} className="space-y-6">
            <Card title="Tag Information" size="small">
                <Row gutter={16}>
                    <Col span={24}>
                        <div className="mb-4">
                            <label className="block text-sm font-medium mb-1">
                                Name *
                            </label>
                            <Controller
                                name="name"
                                control={control}
                                rules={{ required: 'Name is required' }}
                                render={({ field }) => (
                                    <Input
                                        {...field}
                                        placeholder="Enter tag name"
                                        className={errors.name ? 'border-red-500' : ''}
                                    />
                                )}
                            />
                            {errors.name && (
                                <span className="text-red-500 text-xs">
                                    {errors.name.message}
                                </span>
                            )}
                        </div>
                    </Col>
                    <Col span={24}>
                        <div className="mb-4">
                            <label className="block text-sm font-medium mb-1">
                                Description
                            </label>
                            <Controller
                                name="description"
                                control={control}
                                render={({ field }) => (
                                    <TextArea
                                        {...field}
                                        placeholder="Enter tag description"
                                        rows={3}
                                    />
                                )}
                            />
                        </div>
                    </Col>
                    <Col span={24}>
                        <div className="mb-4">
                            <label className="block text-sm font-medium mb-1">
                                Color
                            </label>
                            <div className="flex items-center space-x-4">
                                <div
                                    className="w-8 h-8 rounded border"
                                    style={{ backgroundColor: watchedValues.color }}
                                />
                                <Controller
                                    name="color"
                                    control={control}
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            placeholder="#6c757d"
                                            className="flex-1"
                                        />
                                    )}
                                />
                            </div>
                            <div className="mt-2">
                                <SketchPicker
                                    color={watchedValues.color}
                                    onChange={handleColorChange}
                                    width="100%"
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Card>

            {/* Form Actions */}
            <div className="flex justify-end space-x-4">
                <Button onClick={onCancel}>Cancel</Button>
                <Button type="primary" htmlType="submit">
                    {initialData ? 'Update Tag' : 'Create Tag'}
                </Button>
            </div>
        </form>
    );
}
